export const useReportPage = async () => {
  const route = useRoute()
  const { locale } = useI18n()

  async function getReport() {
    return await useAsyncData(
      `report-${route.path}-${locale.value}`,
      async () => {
        const response = await $fetch('/api/v1/contentful/investor/report', {
          query: {
            locale: locale.value,
            path: route.params.url,
          },
        })

        const report = response.report ?? null
        return report
    })
  }

  return {
    getReport,
  }
}
